<template>
  <div class="videoNow">
    <el-dialog :width="Diawidth" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
               :close-on-click-modal="true" :show-close="true" :close-on-press-escape="true"
               :title="gisclick.ydbName + '视频监测'">
      <!-- <videoInfo style="width: 100%; height: 100%; background-color: transparent;" :url="url"></videoInfo> -->
      <div style="display:flex">
        <video-player style="width:calc(100% - 254px)" class="video-player vjs-custom-skin" ref="videoPlayer"
                      :playsinline="true" :options="playerOptions">
        </video-player>
        <div class="rightVideoWatvh">
          <p>云台控制</p>
          <div class="roadvideo">
            <!-- 上下左右移动 -->
            <div>
              <diV></diV>
              <diV><img @click="move('UP');direction = 1;centImg=0;beforeDire=0" :class="{'active':direction == 1}"
                        src="../../common/images/video/trang.png"/></diV>
              <diV></diV>
            </div>
            <div>
              <diV class="leftImg"><img @click="move('LEFT');direction = 2;centImg=0;beforeDire=0"
                                        :class="{'active':direction == 2}" src="../../common/images/video/trang.png"/>
              </diV>
              <diV class="centImg">
                <img style="transform:none;width:9px" @click="changeCentImg" v-if="centImg == 0 && direction!= 0"
                     src="../../common/images/video/puss.png"/>
                <img v-else @click="changeCentImg" src="../../common/images/video/trang.png"/>
              </diV>
              <diV class="rightImg"><img @click="move('RIGHT');direction = 3;centImg=0;beforeDire=0"
                                         :class="{'active':direction == 3}" src="../../common/images/video/trang.png"/>
              </diV>
            </div>
            <div>
              <diV></diV>
              <diV class="bottomImg"><img @click="move('DOWN');direction = 4;centImg=0;beforeDire=0"
                                          :class="{'active':direction == 4}" src="../../common/images/video/trang.png"/>
              </diV>
              <diV></diV>
            </div>
          </div>
          <div>
            <ul class="lanren">
              <span id="title">0</span>
              <li>
                <span>速度</span>
                <div class="scale_panel">
                  <div class="scale" id="bar">
                    <div class="leftWidth"></div>
                    <span id="btn"></span>
                  </div>
                  <div>
                    <span>0</span><span>100</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div>
            <div><span @mousedown="toIN=true" @mouseup="toIN=false" :class="{'active':toIN}"
                       @click="move('ZOOM_IN')"><b>+</b>焦距变大</span>
              <span @mousedown="toOUT=true" @mouseup="toOUT=false" :class="{'active':toOUT}"
                    @click="move('ZOOM_OUT')"><b>-</b>焦距变小</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  haikangVideo
} from '@/api/api.js'
import 'videojs-contrib-hls'
// import videoInfo from '@/components/visualization/VideoInfo.vue';
export default {
  // props: ['gisclick'],
  data () {
    return {
      dialogVisible: true,
      Diawidth: '65%',
      url: null,
      direction: 0,
      centImg: 1,
      toOUT: false,
      toIN: false,
      beforeDire: 0,
      transmode: 40,//速度
      lastAvtion: '',//上一个
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'application/x-mpegURL', //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: '' //url地址
        }],
        poster: '../../static/images/test.jpg', //你的封面地址
        width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      gisclick: {}
    }
  },
  components: {
    // videoInfo
  },
  mounted () {
    // if(!this.gisclick){
    this.gisclick = JSON.parse(sessionStorage.getItem('gisClick'))
    // }

    // return
    //APPkey:25653044; APPsecret:MbgeY773xx51E60qgGpS
    let params = {
      url: '/artemis/api/resource/v2/camera/search',
      param: {
        pageNo: 1,
        pageSize: 100,
        // name: '东沉沙池'
        name: this.gisclick.ydbCode
      }
    }
    this.haikangVideoFun(params)
    var _that = this

    var scale = function (btn, bar, title) {
      this.btn = document.getElementById(btn)
      this.bar = document.getElementById(bar)
      this.title = document.getElementById(title)
      this.step = document.getElementsByClassName('leftWidth')[0]
      // console.log(this.step)
      this.init()
      this.title.innerHTML = 40
      this.step.style.width = '76px'
      this.title.style.left = 76 + 25 + 'px'
      this.btn.style.left = 76 + 'px'
    }
    scale.prototype = {
      init: function () {
        var f = this, g = document, b = window, m = Math
        f.btn.onmousedown = function (e) {
          var x = (e || b.event).clientX
          var l = this.offsetLeft
          var max = f.bar.offsetWidth - this.offsetWidth
          g.onmousemove = function (e) {
            var thisX = (e || b.event).clientX
            var to = m.min(max, m.max(-2, l + (thisX - x)))
            f.btn.style.left = to + 'px'
            f.ondrag(m.round(m.max(0, to / max) * 100), to)
            b.getSelection ? b.getSelection().removeAllRanges() : g.selection.empty()
          }
          g.onmouseup = function (e) {
            g.onmousemove = null
            _that.move(_that.lastAvtion)
          }

          // g.onmouseup=new Function('this.onmousemove=null');

          // function(e){
          //   new Function('this.onmousemove=null');
          // }
        }
      },
      ondrag: function (pos, x) {
        this.step.style.width = Math.max(0, x) + 'px'
        this.title.innerHTML = pos //标记
        _that.transmode = pos
        this.title.style.left = Math.max(0, x) + 25 + 'px'

      }
    }
    setTimeout(function () {
      // console.log(document.getElementById("bar"))
      new scale('btn', 'bar', 'title')
    }, 200)

  },
  methods: {
    changeCentImg () {
      // console.log(this.direction , this.beforeDire)
      if (this.direction || this.beforeDire) {
        // 0开始 1暂停
        if (this.centImg == 0) {
          // 开始变暂停
          this.centImg = 1
          this.beforeDire = this.direction  //暂存
          this.direction = 0
        } else {
          // 暂停变开始
          this.centImg = 0
          if (this.beforeDire) {
            this.direction = this.beforeDire  //暂存
          }
        }
        this.move(this.lastAvtion)
      }

    },
    handleClose (done) {
      this.dialogVisible = false
      this.$emit('cancel', {
        'dialogVisible': this.dialogVisible
      })
    },
    // 移动
    move (action) {
      this.lastAvtion = action
      let params = {
        url: '/artemis/api/resource/v2/camera/search',
        param: {
          pageNo: 1,
          pageSize: 100,
          // name: '东沉沙池'
          // name: this.gisclick.ydbName,
          name: this.gisclick.ydbCode
        }
      }
      haikangVideo(params).then((res) => {
        if (res.data.list.length != 0) {
          let params1 = {
            url: '/artemis/api/video/v1/ptzs/controlling',
            param: {
              cameraIndexCode: res.data.list[0].indexCode,
              'action': this.centImg, //0 开始 1暂停
              'command': action, //旋转方向
              'transmode': this.transmode //旋转速度
            }
          }
          haikangVideo(params1).then((res) => {
            console.log('---------------》', res.data)

          })

        }
      })

    },

    //根据监控点名称获取符合条件的视频监控点列表.list
    haikangVideoFun (params) {
      let _this = this
      haikangVideo(params).then((res) => {
        console.log(res.data.list)
        if (res.data.list.length != 0) {
          let params1 = {
            url: '/artemis/api/video/v1/cameras/previewURLs',
            param: {
              cameraIndexCode: res.data.list[0].indexCode,
              streamType: 1,
              protocol: 'hls',
              transmode: 1,
              command: ''
            }
          }
          haikangVideo(params1).then((res) => {
            // console.log('---------------》', res.data.url)
            // _this.url = res.data.url;
            if (res.data.url) {
              _this.playerOptions.sources[0].src = res.data.url
            }
          })
        }
      })
    }

    // cancel() { //取消
    //   this.dialogVisible = false;
    //   this.$emit("cancel", {
    //     "dialogVisible": this.dialogVisible
    //   })
    // },
  }
}
</script>

<style lang='scss' scoped>
/* // 右侧视频监测 */
.rightVideoWatvh {
  width: 254px;
  background: #344F6B;
  box-sizing: border-box;
  padding: 5px 6px;

  > div:last-child {
    margin-top: 25px;

    > div {
      display: flex;
      padding: 0 10px;
      justify-content: space-between;

      > span {
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        width: 104px;
        height: 40px;
        background: url(../../common/images/video/rect.png) no-repeat center;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        > b {
          font-size: 20px;
          margin-top: -3px;
          margin-right: 5px;
        }
      }

      .active {
        color: #00B3FE;
      }
    }
  }

  > p {
    height: 44px;
    background: #102944;
    line-height: 44px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    position: relative;
    text-indent: 20px;
  }

  > p::before {
    content: '';
    position: absolute;
    left: 13px;
    width: 3px;
    height: 15px;
    background: #FFFFFF;
    border-radius: 2px;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}

.roadvideo {
  width: 165px;
  height: 165px;
  margin: 20px auto 5px;
  background: url(../../common/images/video/road.png) no-repeat;
  background-size: 100% 100%;

  > div {
    height: 55px;
    display: flex;

    > div {
      width: 55px;
      height: 55px;
      display: flex;
      align-items: center;
      justify-content: center;

      > img {
        width: 13px;
        filter: grayscale(100%) brightness(200%);
        cursor: pointer;
      }

      .active {
        filter: grayscale(0);
      }
    }

    .bottomImg {
      > img {
        transform: rotateX(180deg);
      }
    }

    .leftImg {
      > img {
        transform: rotateY(180deg) rotateZ(90deg);
      }
    }

    .centImg > img {
      margin-left: 5px;
    }

    .rightImg, .centImg {
      > img {
        transform: rotateY(180deg) rotateZ(-90deg);
      }
    }
  }
}

.lanren > li > span {
  color: #fff;
  margin-right: 10px;
  font-size: 14px;
}

.scale_panel > div:last-child {
  display: flex;
  justify-content: space-between;
  color: #fff;
  margin-top: 5px;
}

.scale_panel {
  color: #999;
  width: 190px;
  line-height: 18px;
}

.scale_panel .r {
  float: right;
}

.scale span {
  background: url(../../common/images/video/scroll.png) no-repeat;
  width: 16px;
  height: 16px;
  position: absolute;
  left: -5px;
  top: -3px;
  cursor: pointer;
  background-size: 100% 100%;
}

.scale {
  border-radius: 5px;
  background-repeat: repeat-x;
  background-position: 0 100%;
  height: 10px;
  background: #07070733;
  width: 190px;
  position: relative;
  font-size: 0px;
  border-radius: 3px;
}

.scale div {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  background-repeat: repeat-x;
  height: 10px;
  background: #626060;
  width: 0px;
  position: absolute;
  width: 0;
  left: 0;
  bottom: 0;
}

.lanren li {
  font-size: 12px;
  line-height: 50px;
  position: relative;
  height: 50px;
  list-style: none;
  display: flex;
  align-items: flex-end;
}

.lanren {
  padding-top: 35px;
  position: relative;
}

#title {
  background: #454545;
  border-radius: 6px;
  padding: 3px 6px;
  border-radius: 6px;
  position: absolute;
  top: 14px;
  left: 25px;
  color: #fff;
}


/deep/ .el-dialog {
  height: 600px;
  background: url(../../common/images/dialog.png) no-repeat center;
  background-size: 100% 100%;
}

/deep/ .el-dialog__body {
  padding-top: 0;
}

/deep/ .el-dialog__header {
  /* border: none; */
  padding-left: 0;
  margin: 10px 20px 8px 20px;
}

/deep/ .el-dialog__body, .el-dialog__footer {
  background: transparent;
}

.Diatitles {
  width: 100%;
  height: 30px;
  border-bottom: 1px solid #214e69;
  /* background-color: #ffe557; */
}

.Diatitles li {
  float: left;
  padding: 0px 20px;
  line-height: 30px;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}
</style>
